import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import Image from "next/legacy/image";
import useWindowSize from '../../hooks/useWindowSize';
import Arrow from '../Icons/Arrow';
import Close from '../Icons/Close';
const Modal = dynamic(() => import('../ModalSlider/ModalSlider'));

export default function ProdSliderModal({
  setModalOpen,
  setIsImported,
  images,
  modalOpen,
  alt
}: {
  alt: string;
  modalOpen: boolean;
  images: any;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsImported: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { width } = useWindowSize();
  const [currentSlideModal, setCurrentSlideModal] = useState(0);

  return (
    <Modal
      className="m-auto mdx:w-full"
      onClose={() => setModalOpen(false)}
      onCallEndAnimate={() => setIsImported(false)}
      open={modalOpen}>
      <div className="flex items-end flex-col">
        <button className="mb-2" onClick={() => setModalOpen(false)}>
          <Close />
        </button>

        {width >= 768 && (
          <>
            <button
              className="flex absolute top-2/4 left-[15px] -translate-y-full items-center justify-center transform rotate-90 w-8 h-8 rounded-full bg-brand-grey1253"
              onClick={() => {
                setCurrentSlideModal(
                  currentSlideModal == 0
                    ? images.length - 1
                    : currentSlideModal - 1
                );
              }}>
              <Arrow fill="white" width={31.5} height={18} />
            </button>
            <button
              className="flex absolute top-2/4 right-[15px] -translate-y-full items-center justify-center transform -rotate-90 w-8 h-8 rounded-full bg-brand-grey1253"
              onClick={() => {
                setCurrentSlideModal(
                  currentSlideModal == images.length - 1
                    ? 0
                    : currentSlideModal + 1
                );
              }}>
              <Arrow fill="white" width={31.5} height={18} />
            </button>
          </>
        )}
        <div className="flex flex-col w-[625px] h-[640px] mdx:w-full xsmx:h-[380px] xxsmx:h-[320px]">
          <div className="flex relative w-full h-full bg-white">
            <Image
              layout="fill"
              placeholder="blur"
              objectFit="contain"
              blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO8Uw8AAj0BXe1cD0IAAAAASUVORK5CYII="
              src={images[currentSlideModal]}
              alt={alt}
              quality={50}
              priority
            />
          </div>
          <div className="py-1 text-white text-[10px] font-sans font-normal flex w-full justify-end">
            {currentSlideModal + 1} / {images.length}
          </div>
        </div>
        <div className="flex mx-auto items-center justify-center">
          <button
            className="flex items-center justify-center transform rotate-90 w-8 h-8 rounded-full bg-brand-grey1253"
            onClick={() => {
              setCurrentSlideModal(
                currentSlideModal == 0
                  ? images.length - 1
                  : currentSlideModal - 1
              );
            }}>
            <Arrow fill="white" width={21} height={12} />
          </button>

          {images.map((sld: any, i: number) => (
            <div
              key={i}
              onClick={() => {
                setCurrentSlideModal(i);
              }}
              className="cursor-pointer relative mx-2 overflow-auto rounded w-[50px] h-[50px] bg-white">
              <Image
                placeholder="blur"
                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO8Uw8AAj0BXe1cD0IAAAAASUVORK5CYII="
                layout="fill"
                objectFit="cover"
                src={sld}
                quality={50}
                alt={alt}
              />
            </div>
          ))}

          <button
            className="flex items-center justify-center transform -rotate-90 w-8 h-8 rounded-full bg-brand-grey1253"
            onClick={() => {
              setCurrentSlideModal(
                currentSlideModal == images.length - 1
                  ? 0
                  : currentSlideModal + 1
              );
            }}>
            <Arrow fill="white" width={21} height={12} />
          </button>
        </div>
      </div>
    </Modal>
  );
}
